/** Broker-Cloud — Antwortformen von /api/broker-hub/cloud (node-app/src/routes/broker-hub-cloud.ts). */

export interface CloudConfig {
  enabled: boolean;
  hidden: number[];
  order: number[];
  compareHref: string | null;
  compareLabel: string;
  disclosureText: string;
  style: {
    linkColor: string;
    noteColor: string;
    background: string;
    maxWidth: number;
    logoHeight: number;
    gap: number;
    marginTop: number;
    marginBottom: number;
    align: 'start' | 'center';
  };
}

export interface CloudEntry {
  brokerId: number;
  name: string;
  slug: string;
  logoUrl: string;
  href: string;
}

export type CloudExclusionReason =
  | 'no_profile'
  | 'not_live'
  | 'never_deployed'
  | 'taken_down'
  | 'no_page_url'
  | 'broker_inactive'
  | 'no_logo'
  | 'id_out_of_range'
  | 'hidden';

export interface CloudExcluded {
  brokerId: number;
  name: string;
  reason: CloudExclusionReason;
}

export const EXCLUSION_LABEL: Record<CloudExclusionReason, string> = {
  no_profile: 'kein Profil auf diesem Portal',
  not_live: 'Profil nicht live',
  never_deployed: 'Profil nie ausgespielt',
  taken_down: 'Profil zurückgezogen',
  no_page_url: 'keine Seiten-Adresse',
  broker_inactive: 'Broker inaktiv',
  no_logo: 'kein Katalog-Logo',
  id_out_of_range: 'Broker-Nummer zu groß (> 64)',
  hidden: 'ausgeblendet',
};

export interface CloudSiteStatus {
  site_key: string;
  name: string;
  base_url: string;
  config: CloudConfig;
  default_compare_href: string | null;
  entries: CloudEntry[];
  excluded: CloudExcluded[];
  computed_sha: string;
  published: {
    sha: string;
    published_at: string;
    broker_ids: number[];
    object_path: string;
  } | null;
  in_sync: boolean;
  last_error: { at: string; message: string } | null;
  object_path: string;
  file_url: string | null;
  embed: string;
}

export interface CloudStatus {
  sites: CloudSiteStatus[];
  publishes_to_prod: boolean;
}

export interface CloudPreview {
  code: string;
  config: CloudConfig;
  entries: CloudEntry[];
  excluded: CloudExcluded[];
}

export interface CloudReportRow {
  period: string;
  site_key: string;
  broker_id: number;
  broker_name: string;
  views_clean: number;
  views_flagged: number;
  clicks_clean: number;
  clicks_flagged: number;
}
